import Model from './Model'
import {isNull} from "lodash";

export default class InspectionTestPlan extends Model {
    static async list(packageId) {
        const data = await Http.get(route('api.v2.inspection-test-plans.list', {package_reference: packageId}))
        return this.make(data)
    }

    static async find(packageReference,id) {
        const data = await Http.get(route('api.v2.inspection-test-plans', [packageReference, id]))
        return this.make(data);
    }

    static async create(packageReference, id, attributes = {}) {
        const success = await Http.post(route('api.v2.inspection-test-plans.create', [packageReference, id]), attributes);
        const data = await Http.get(route('api.v2.inspection-test-plans', [packageReference, id]))
        return this.make(data)
    }

    getFormAttributes() {
        let ret = this.except(['activityLog', 'id', 'saving', 'saveAgain']);
        //TODO - removed nested defaultXXX params
        return ret;
    }

    async update(attributes = {}) {
        const url = route('api.v2.inspection-test-plans.store', [this.packageReference, this.id])
        const payload = this.constructor.parseAttributes({...this.getFormAttributes(), ...attributes})
        const success = await Http.put(url, payload)
        const data = await Http.get(route('api.v2.inspection-test-plans', [this.packageReference, this.id]))
        return this.fill(data)
    }

    async delete() {
        await Http.delete(route('api.v2.inspection-test-plans.delete', [this.packageReference, this.id]))
    }
    

    static make(attributes = {}) {
        let obj = super.make(attributes);
        if (obj.sections) {
            obj.sections.forEach((section, si, sa) => {
                sa[si].defaultTitle = 'Untitled Section ' + (si + 1)
                sa[si].tasks.forEach((task, ti, ta) => {
                    ta[ti].defaultReference = (si + 1) + '.' + (ti + 1)
                    ta[ti].items.forEach((item, ii, ia) => {
                        ia[ii].defaultReference = (si + 1) + '.' + (ti + 1) + '.' + (ii + 1)
                    })
                })
            })
        }
        return obj;
    }

    setAttributes(attributes) {
        super.setAttributes(attributes);
        let tokens = [
            attributes.packageReference,
        ]
        this.tokens = tokens.join('|').toLowerCase();
    }

    disableSnapshots = false

    addSnapshot() {
        if (this.disableSnapshots) return
        let store = this.getSnapshotStore()
        let data = JSON.stringify(this.except(['saving', 'saveAgain']))
        if (store.states[store.states.length - 1] !== data) {
            store.states.push(data);
            this.putSnapshotStore(store)
            eventBus.$emit('inspection-test-plan-history-state-updated', {inspectionTestPlan: this, states: store.states})
        }
    }
    clearSnapshots(fromPosition, count = null) {
        const store = this.getSnapshotStore()
        store.states.splice(fromPosition, isNull(count) ? store.states.length - fromPosition : count)
        this.putSnapshotStore(store);
    }

    getSnapshotStore() {
        let store = localStorage.getItem('inspection-test-plans-history:' + this.id)
        store = store ? JSON.parse(store) : {states: []}
        return store
    }

    putSnapshotStore(store) {
        localStorage.setItem('inspection-test-plans-history:' + this.id, JSON.stringify(store))
    }
}
